<template>
  <div>
    <div class="table_view" v-loading="loading">
      <el-table
        ref="tabledata"
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column type="index" label="序号" width="80">
        </el-table-column>

        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150px"
          label-height="50"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <!-- <p>
          共有{{ total }}条记录，当前第{{ currentPage3 + 1 }}/{{ pagesun }}页
        </p> -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="showpageindex"
          :page-size="pageSize"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import yklFirst from "@/api/visualization";
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      formColumns: [
        {
          prop: "RealName",
          label: "考生姓名",
        },
        {
          prop: "UserName",
          label: "考生账号",
        },
        {
          prop: "phone",
          label: "手机号",
        },
        {
          prop: "hospitalName",
          label: "医院名称",
        },
        {
          prop: "dptName",
          label: "科室",
        },
        {
          prop: "PTitle",
          label: "职称",
        },
        {
          prop: "pointName",
          label: "模块名称",
        },
        {
          prop: "pointCount",
          label: "总点击次数(次)",
        },
      ],
      showpageindex: 1, //显示的索引盒子
      currentPage3: 0, //  当前页数
      pageSize: 10, //每页的条数
      pagesizesarr: [5, 10, 20, 50, 100],
      pagesun: "", //一共多少页
      total: 100, //总条数
    };
  },
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 获取三级表格
    async getThreeTable() {
      this.$nextTick(() => {
        // let newTimes = this.$moment().format("YYYY-MM-DD"); // 当前天数（当前系统的时间）
        // this.$parent.timeData[0] = newTimes; // 默认今天时间    // 时间参数清空
        // this.$parent.timeData[1] = newTimes; // 默认今天时间
        if (this.$parent.timeData) {
          const time = JSON.parse(JSON.stringify(this.$parent.timeData));
          this.$parent.formLabelAlign.examBeginDate = this.$moment(
            time[0]
          ).format("YYYY-MM-DD HH:mm:ss");
          this.$parent.formLabelAlign.examEndDate = this.$moment(
            time[1]
          ).format("YYYY-MM-DD HH:mm:ss");
        }
      });
      const obj = {
        pointId: this.$parent.pointId,
        pageindex: this.currentPage3,
        pageSize: this.pageSize,
        clsContent:this.$parent.clsVnName == null ?'':this.$parent.clsVnName,
        beginTime: this.$parent.timeData[0] + " 00:00:00", // 开始时间
        endTime: this.$parent.timeData[1] + " 23:59:59", // 结束时间
      };
      const { data } = await yklFirst.yklEventDetail(obj);
      if (data.Status == 200) {
        this.tableData = data.Data.list;
        this.total = data.Data.total
        console.log(data);
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(data.Data);
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.formLabelAlign.eachPageNum = val;
      this.getDatalist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.formLabelAlign.pageIndex = val - 1;
      this.loading = true;
      this.getDatalist();
    },
  },
  created() {
    this.getThreeTable();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
</style>